'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);

var _formatPhoneNumber = require('../../../utils/formatPhoneNumber');
var _analyticsManager = require('../../../utils/analytics/analyticsManager');
var _analyticsConstants = require('../../../utils/analytics/analyticsConstants');
var _services = require('../../../services');
var _constants = require('../../../constants');
var _components = require('../../../components');

var _Contacts = require('./Contacts.scss');var styles = _interopRequireWildcard(_Contacts);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;}var

Contacts = function (_Component) {_inherits(Contacts, _Component);function Contacts() {var _temp, _this, _ret;_classCallCheck(this, Contacts);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.
    state = {
      phoneIsRevealed: {
        primary: false,
        secondary: false },

      showTooltip: false }, _this.


    handleClick = function () {var
      id = _this.props.id;

      if (!_this.state.phoneIsRevealed.primary) {
        _this.handleShowPhone();
      } else {
        (0, _analyticsManager.trackGTM)({ name: _analyticsConstants.eventCategory.contactViews });
        _services.AnalyticsEventService.createPropertyEvent({ id: id, action: _constants.analyticsEventAction.SHOW_NUMBER });
        (0, _analyticsManager.trackEvent)(_analyticsConstants.eventCategory.propertyDetails, _analyticsConstants.eventAction.show, _analyticsConstants.eventLabel.phoneNumber);
      }
    }, _this.

    handleShowPhone = function () {var _Object$assign;var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'primary';var
      id = _this.props.id;

      (0, _analyticsManager.trackGTM)({ name: _analyticsConstants.eventCategory.contactViews });
      _services.AnalyticsEventService.createPropertyEvent({ id: id, action: _constants.analyticsEventAction.SHOW_NUMBER });
      (0, _analyticsManager.trackEvent)(_analyticsConstants.eventCategory.propertyDetails, _analyticsConstants.eventAction.show, _analyticsConstants.eventLabel.phoneNumber);

      return _this.setState({
        phoneIsRevealed: Object.assign({},
        _this.state.phoneIsRevealed, (_Object$assign = {}, _Object$assign[
        type] = true, _Object$assign)),

        showTooltip: true },
      function () {
        setTimeout(function () {
          _this.setState({
            showTooltip: false });

        }, 3000);
      });
    }, _this.

    handleClickButtonScroll = function () {
      _this.props.scrollToForm();

      if (!_this.props.isForeign) {
        (0, _analyticsManager.trackGTM)({ name: _analyticsConstants.eventCategory.startNewProject });
      }
    }, _this.

    renderContactButton = function () {var _this$props =
      _this.props,translate = _this$props.translate,phoneNumber = _this$props.phoneNumber,isMobile = _this$props.isMobile;

      var title = _this.props.translate('propertyDetails', 'contacts', 'onMapTitle').split('%s');
      title.splice(1, 0, _react2.default.createElement('span', { key: 'contacts', className: styles.logoTitle }, 'OnMap'));

      if (isMobile) {
        return (
          _react2.default.createElement('a', {
              href: 'tel:' + (0, _formatPhoneNumber.authenticationFormatPhoneNumber)(phoneNumber),
              className: (0, _classnames2.default)(styles.hideText, styles.phone),
              onClick: _this.handleClick },

            _react2.default.createElement('span', { className: (0, _classnames2.default)('icon icon-phone-fill', styles.iconsIndent) }),

            _this.state.phoneIsRevealed.primary ?
            (0, _formatPhoneNumber.formatPhoneNumber)((0, _formatPhoneNumber.clearPhoneNumber)(phoneNumber)) :
            translate('propertyDetails', 'contacts', 'showNumber')));



      }


      return _this.state.phoneIsRevealed.primary ?
      _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.hideText, styles.textRevealed) },
        (0, _formatPhoneNumber.formatPhoneNumber)((0, _formatPhoneNumber.clearPhoneNumber)(phoneNumber)),
        _this.state.showTooltip &&
        _react2.default.createElement(_components.OMTooltip, {
          locale: _this.props.locale,
          className: 'contact',
          msg:
          _react2.default.createElement('p', { className: styles.message }, title),

          hideCloseButton: true })) :




      _react2.default.createElement('div', { className: styles.hideText, onClick: function onClick() {return _this.handleShowPhone('primary');} },
        _react2.default.createElement('span', { className: (0, _classnames2.default)('icon icon-phone-fill', styles.iconsIndent) }),
        translate('propertyDetails', 'contacts', 'showNumber'));


    }, _temp), _possibleConstructorReturn(_this, _ret);}Contacts.prototype.

  render = function render() {var _props =
    this.props,isUnlimitedLeads = _props.isUnlimitedLeads,phoneNumber = _props.phoneNumber,scrollToForm = _props.scrollToForm,translate = _props.translate;

    return (
      _react2.default.createElement('div', { className: styles.contactsContainer },
        _react2.default.createElement('div', null,
          isUnlimitedLeads && phoneNumber && this.renderContactButton(),
          _react2.default.createElement('button', {
              type: 'button',
              className: (0, _classnames2.default)(styles.hideText, styles.scrollButton),
              onClick: scrollToForm },

            translate('propertyDetails', 'contacts', 'writeToSeller')))));




  };return Contacts;}(_react.Component);


Contacts.propTypes = {
  translate: _propTypes2.default.func,
  phoneNumber: _propTypes2.default.string,
  isForeign: _propTypes2.default.bool,
  isUnlimitedLeads: _propTypes2.default.bool,
  id: _propTypes2.default.string,
  scrollToForm: _propTypes2.default.func,
  isMobile: _propTypes2.default.bool,
  locale: _propTypes2.default.string };exports.default =


Contacts;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ProjectDetailedInfo/Contacts/Contacts.js
// module id = 2767
// module chunks = 0